import { render } from "./status.vue?vue&type=template&id=3c8535fd&scoped=true&ts=true"
import script from "./status.vue?vue&type=script&scoped=true&lang=ts"
export * from "./status.vue?vue&type=script&scoped=true&lang=ts"

import "./status.vue?vue&type=style&index=0&id=3c8535fd&lang=css"
import "./status.vue?vue&type=style&index=1&id=3c8535fd&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8535fd"]])

export default __exports__